import $, { Cash } from 'cash-dom'
import { proxy } from '../../resources/proxy'
import { ShareSheet } from '../share-sheet'

class ReferralForm {
  container: Cash
  content: Cash
  form: Cash
  formStep1: Cash
  shareDiv: Cash
  shareContainer: Cash
  getLinkButton: Cash
  referrerEmailInput: Cash
  formErrorStep1: Cash
  referrerEmail: string = ''
  referralLink: string = ''
  shareSheet: ShareSheet | null = null

  constructor(container: Cash) {
    this.container = $(container)
    this.content = this.container.find('[data-referral-content-container]')
    this.form = this.container.find('[data-yotpo-referral-form]')
    this.formStep1 = this.container.find('[data-yotpo-referral-form-step1]')
    this.shareDiv = this.container.find('[data-yotpo-referral-share]')
    this.shareContainer = this.shareDiv.find('[data-referral-share-container]')

    this.getLinkButton = this.formStep1.find(
      '[data-action="get-referral-link"]'
    )
    this.referrerEmailInput = this.formStep1.find('[name="referrer_email"]')

    this.formErrorStep1 = this.formStep1.find('[data-form-error]')

    if (this.referrerEmailInput.prop('readonly')) {
      this.getLinkButton.prop('disabled', false)
      this.referrerEmailInput.closest('.input-group').attr('data-valid', 'true')
    }

    this.bindEvents()
  }

  bindEvents(): void {
    this.formStep1.on('submit', (e: Event) => this.handleStep1Submit(e))
  }

  initShareSheet(linkUrl: string, containerElement: Cash): void {
    const shareSheetContainer = containerElement.find(
      '[data-share-sheet-container]'
    )

    this.shareSheet = new ShareSheet(containerElement, {
      url: linkUrl,
      title: shareSheetContainer.data('share-title'),
      text: shareSheetContainer.data('share-text'),
      updateUrls: true,
    })
  }

  async handleStep1Submit(e: Event) {
    e.preventDefault()
    this.formErrorStep1.addClass('hidden').text('')
    this.referrerEmail = this.referrerEmailInput.val() as string
    this.getLinkButton.prop('disabled', true)

    try {
      const { data } = await proxy('/referral/identify-referrer', {}, 'POST', {
        email: this.referrerEmail,
      })

      if (data.referral_link) {
        this.referralLink = `https://${data.referral_link}`

        this.formStep1.addClass('hidden')
        this.content.addClass('hidden')
        this.shareDiv.removeClass('hidden')

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            const currentShareContainer = this.shareDiv.find(
              '[data-referral-share-container]'
            )
            if (currentShareContainer.length > 0) {
              this.initShareSheet(this.referralLink, currentShareContainer)
            }
          })
        })
      } else {
        const errorMessage =
          data.message ??
          (typeof data.referral_link !== 'undefined'
            ? 'Received an invalid referral link.'
            : 'Could not retrieve referral link.')

        this.formErrorStep1.text(errorMessage).removeClass('hidden')
        this.getLinkButton.prop('disabled', false)

        setTimeout(() => {
          this.formErrorStep1.addClass('hidden').text('')
        }, 5000)
      }
    } catch (error) {
      console.error('Get referral link error:', error)
      this.formErrorStep1
        .text('A network error occurred. Please try again.')
        .removeClass('hidden')

      setTimeout(() => {
        this.formErrorStep1.addClass('hidden').text('')
      }, 5000)
    }
  }
}

$(document).ready(() => {
  $('[data-referral-form-container]').each((_, el) => {
    const _formInstance = new ReferralForm(el)
  })
})
